// @ts-check
import createNumericRangeFacet from '../createNumericRangeFacet';

export default createNumericRangeFacet({
  stateKey: 'price',
  itemKey: 'price',
  configKey: 'filterPriceRange',
});
